import * as Yup from 'yup';

export const validationSchema = Yup.object({
  phase: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Phase is required')
    .nullable(),
  documentType: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Document Type is required')
    .nullable(),
  deliverableId: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  name: Yup.string().max(50, 'Character length exceeds 50').required('Required'),
  summary: Yup.string().max(200, 'Character length exceeds 200').required('Required'),
  documents: Yup.array().min(1, 'At least one file is required').required('Required'),
});
